module.exports = __webpack_public_path__ + "cdd80474ab0344fbb9d3778a0a98857b.svg";